var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[(_vm.selItem)?_c('this-background',{attrs:{"item":_vm.selItem}}):_vm._e(),_c('this-catalog',{attrs:{"items":_vm.items},on:{"select":_vm.handleSelect}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }